import React, { useState, useContext } from "react";
import "./Navbar.css";
import logo from "../Assets/logo.png";
import cart_icon from "../Assets/cart_icon.png";
import { Link } from "react-router-dom";
import { ShopContext } from "../../Context/ShopContext";

const Navbar = () => {
  const { getTotalCartItems } = useContext(ShopContext);
  const [activeMenu, setActiveMenu] = useState("shop");
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    if (!isMenuOpen) setActiveDropdown(null);
  };

  const toggleDropdown = (menuName) => {
    setActiveDropdown(activeDropdown === menuName ? null : menuName);
  };

  const handleMenuItemClick = (item) => {
    setActiveMenu(item.name);
    if (!item.dropdown) {
      setIsMenuOpen(false);
    } else if (window.innerWidth <= 768) {
      toggleDropdown(item.name);
    }
  };

  const handleSubItemClick = () => {
    setIsMenuOpen(false);
  };

  const menuItems = [
    {
      name: "shop",
      path: "/",
      label: "Shop",
      dropdown: null
    },
    {
      name: "medical",
      path: "/medical",
      label: "Medical Equipment",
      dropdown: {
        subcategories: [
          { name: "Diagnostic Devices", path: "/medical/diagnostic-devices" },
          { name: "Surgical Instruments", path: "/medical/surgical-instruments" }
        ]
      }
    },
    {
      name: "lab",
      path: "/lab",
      label: "Lab Equipment",
      dropdown: {
        subcategories: [
          { name: "Glassware", path: "/lab/glassware" },
          { name: "Electronic Devices", path: "/lab/electronic-devices" }
        ]
      }
    },
    {
      name: "reagent",
      path: "/reagent",
      label: "Reagents",
      dropdown: {
        subcategories: [
          { name: "Biochemical Reagents", path: "/reagent/biochemical-reagents" },
          { name: "Stains and Indicators", path: "/reagent/stains-indicators" }
        ]
      }
    },
    {
      name: "chemical",
      path: "/chemical",
      label: "Chemical",
      dropdown: {
        subcategories: [
          { name: "Acids", path: "/chemical/acids" },
          { name: "Bases", path: "/chemical/bases" },
          { name: "Solvents", path: "/chemical/solvents" },
          { name: "Salts", path: "/chemical/salts" }
        ]
      }
    }
  ];

  return (
    <div className="navbar">
      <div className="nav-logo">
        <Link to='/'><img src={logo} alt="Nexus Med Logo" />        </Link>

        <p>Nexus Med</p>
      </div>
      
      <ul className={`nav-menu ${isMenuOpen ? 'active' : ''}`}>
        {menuItems.map((item) => (
          <li 
            key={item.name}
            onMouseEnter={() => window.innerWidth > 768 && item.dropdown && toggleDropdown(item.name)}
            onMouseLeave={() => window.innerWidth > 768 && item.dropdown && toggleDropdown(item.name)}
          >
            <div className="menu-item-container">
              <Link 
                to={item.path} 
                onClick={() => handleMenuItemClick(item)}
                className={activeMenu === item.name ? "active" : ""}
              >
                {item.label}
              </Link>
              {item.dropdown && (
                <button 
                  className="mobile-dropdown-toggle"
                  onClick={() => toggleDropdown(item.name)}
                  aria-expanded={activeDropdown === item.name}
                >
                  {activeDropdown === item.name ? '−' : '+'}
                </button>
              )}
            </div>
            
            {item.dropdown && (
              <div 
                className={`dropdown-menu ${activeDropdown === item.name ? 'active' : ''}`}
              >
                {item.dropdown.subcategories.map((sub) => (
                  <Link 
                    key={sub.name}
                    to={sub.path}
                    className="dropdown-item"
                    onClick={handleSubItemClick}
                  >
                    {sub.name}
                  </Link>
                ))}
              </div>
            )}
          </li>
        ))}
      </ul>
      
      <div className="nav-login-cart">
        <Link to="/login">
          <button>Login</button>
        </Link>
        <Link to="/cart" className="cart-link">
          <img src={cart_icon} alt="Cart" />
          <div className="nav-cart-count">{getTotalCartItems()}</div>
        </Link>
      </div>
      <button className={`mobile-menu-toggle ${isMenuOpen ? 'active' : ''}`} onClick={toggleMenu}>
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
  );
};

export default Navbar;